import React, { useCallback, useState, useEffect } from 'react';
import styled from 'styled-components';
import { ErrorMsg, Row } from '../../../../styles/common';
import theme from "../../../../styles/theme";
import NaviText from '../../common/NaviText';
import { FormControl, Select, InputLabel, TextField, MenuItem, Fade } from '@mui/material';
import { useSetItem } from '../../../../interface/item';
import Button from '../../../common/Button';
import { useGetCodeList, useGetUserList } from '../../../../interface/common';
import moment from 'moment';
import MsgModal from '../../../common/modal/MsgModal';
import { useGetSuppCategoryList, useSetSupplies } from '../../../../interface/supplies';

const MainWrap = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    .label {
        // display: flex;
        // align-items: center;//stretch;
        padding: 4px;
        min-width: 8rem;
        height: calc(100% - 8px);
        font-size:${theme.fontSize.base};
        // background: ${theme.color.black[40]};
        // border: 1px solid red;
    }
    .naviBar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid ${theme.color.black[10]};
        position:sticky;
        top:0px;
        background: ${theme.color.white[100]};
        z-index:1200;
    }
    // .close {
    //     position: absolute;
    //     top: 0px;
    //     right: 0;
    // }
`;

const Detail = ({item, onClose}) => {

    const [errorMsg, setErrorMsg] = useState();
    const [sendParam, setSendParam] = useState(item ? item : {});
    const [delMsgToggle,setDelMsgToggle] = useState(false);

    const {data : supCdList} = useGetCodeList('sup_cd');
    const {data : supStList} = useGetCodeList('sup_st');
    const { mutate, error } = useSetSupplies();
    const {data : userList} = useGetUserList();

    const { data: suppCateList, isLoading: suppCateLoading } = useGetSuppCategoryList();

    const handleValueChange = (id, val) => {
        const temp = sendParam;
        temp[id]=val;
        setSendParam(temp);
    }

    const handleRegClick = useCallback((sendItem) => {
        if(sendItem ){
            if(sendItem.cnt && sendItem.cnt > 0){
                sendItem['mode'] = 'POST_LIST'
            }else{
                sendItem['mode'] = 'POST'
            }
            mutate(
                sendItem,
                {
                    onSuccess:()=>{
                        onClose(false);
                    },
                    onError:(e)=>{
                        console.log('등록실패',e);
                    }
                }
            );
        }
    },[mutate]);

    const handleModClick = useCallback((sendItem) => {
        sendItem['mode'] = 'PUT'
        mutate(
            sendItem,
            {
                onSuccess:()=>{
                    onClose(false);
                },
                onError:(e)=>{
                    console.log('수정실패',e);
                }
            }
            );
    },[mutate]);

    const handleDelConfirm = () => {
        setDelMsgToggle(true)
    }

    const handleDelClick = useCallback((sendItem) => {
        if(sendItem && sendItem.sid) {
            const delParam = {
                mode: 'DELETE',
                sid: sendItem.sid
            }
            mutate(delParam);
            onClose(false);
        }
    },[mutate]);

    return (
        <MainWrap>
            <div className='naviBar'>
                <NaviText target={[{text:'소모품 관리'},{text: item ? '소모품 상세' : '소모품 등록'}]} />
                <div className='close' onClick={()=>onClose(false)}>
                    <img src={`/images/ic_close.svg`} />
                </div>
            </div>
            <div
                style={{
                    marginTop: '12px',
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start'
                }}
            >
                <Row style={{alignItems:'baseline',margin:'0px'}}>
                    {!item &&
                        <TextField 
                            id='cnt' 
                            label='개수' 
                            size='small' 
                            style={{width:'8.5rem'}}
                            InputLabelProps={{shrink:true}} 
                            onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                        />
                    }
                    <FormControl style={{width:'10rem',margin:'8px 0px 16px 0px'}} size='small'>
                        <InputLabel id='cateogry-label'>분류</InputLabel>
                        <Select label="분류" labelId='cateogry-label' size='small' defaultValue={item && item.cid ? item.cid : ''}>
                            <MenuItem value={''} onClick={(e)=>handleValueChange('cid','')} >없음</MenuItem>
                            {suppCateList && suppCateList[0].map((item,index)=>{
                                return <MenuItem 
                                            key={index} 
                                            value={item.cid} 
                                            onClick={()=>handleValueChange('cid',item.cid)}
                                        >
                                            {item.cat_nm}
                                        </MenuItem>
                            })}
                        </Select>
                    </FormControl>
                    <TextField 
                        id='model_nm' 
                        label='모델명' 
                        size='small' 
                        style={{width:'8.5rem'}}
                        InputLabelProps={{shrink:true}} 
                        defaultValue={item && item.model_nm}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    <TextField 
                        id='model_sub' 
                        label='모델유형' 
                        size='small' 
                        style={{width:'8.5rem'}}
                        InputLabelProps={{shrink:true}} 
                        defaultValue={item && item.model_sub}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    <TextField 
                        id='lot_no' 
                        label='표기번호' 
                        size='small' 
                        style={{width:'10rem'}} 
                        InputLabelProps={{shrink:true}} 
                        defaultValue={item && item.lot_no}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                <Row>
                    <FormControl style={{width:'10rem'}} size='small'>
                        <InputLabel id='supCd-label'>소모품용도</InputLabel>
                        <Select label="소모품용도" labelId='supCd-label' size='small' defaultValue={item && item.sup_cd ? item.sup_cd : ''}>
                            <MenuItem value={''} onClick={()=>handleValueChange('sup_cd','')} >없음</MenuItem>
                            {supCdList && supCdList.map((item,index)=>{
                                return <MenuItem 
                                            key={index} 
                                            value={item.code} 
                                            onClick={()=>handleValueChange('sup_cd',item.code)}
                                        >
                                            {item.value}
                                        </MenuItem>
                            })}
                        </Select>
                    </FormControl>
                    <FormControl style={{width:'10rem'}} size='small'>
                        <InputLabel id='supSt-label'>소모품상태</InputLabel>
                        <Select label="소모품상태" labelId='supSt-label' size='small' defaultValue={item && item.sup_st ? item.sup_st : ''}>
                            <MenuItem value={''} onClick={()=>handleValueChange('')} >없음</MenuItem>
                            {supStList && supStList.map((item,index)=>{
                                return <MenuItem 
                                            key={index} 
                                            value={item.code} 
                                            onClick={()=>handleValueChange('sup_st',item.code)}
                                        >
                                            {item.value}
                                        </MenuItem>
                            })}
                        </Select>
                    </FormControl>
                </Row>
                <Row>
                    <TextField 
                        id='spec' 
                        label='사양' 
                        fullWidth 
                        multiline 
                        rows={2} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        defaultValue={item && item.spec}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                <Row>
                    <TextField 
                        id='pur_date'
                        label='구매일자' 
                        style={{width:'10rem'}} 
                        InputLabelProps={{shrink:true}} 
                        type='date' 
                        size='small'
                        defaultValue={item && moment(item.pur_date,'YYYYMMDD').format('YYYY-MM-DD')}
                        onChange={(e)=>handleValueChange(e.target.id,moment(e.target.value,'YYYY-MM-DD').format('YYYYMMDD'))}
                    />
                    <FormControl style={{width:'8rem'}} size='small'>
                        <InputLabel id='uid-label'>사용자</InputLabel>
                        <Select label="사용자" labelId='uid-label' size='small' defaultValue={item && item.uid}>
                            {userList && userList.map((item,index)=>{ 
                                return <MenuItem 
                                            key={index} 
                                            value={item.uid}
                                            onClick={()=>handleValueChange('uid',item.uid)}
                                        >
                                            {item.user_nm}
                                        </MenuItem>
                            })}
                        </Select>
                    </FormControl>
                </Row>
                <Row>
                    <TextField 
                        id='contents' 
                        label='사용내용' 
                        fullWidth 
                        multiline 
                        rows={4} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        defaultValue={item && item.contents}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                <Row>
                    <TextField 
                        id='descr' 
                        label='세부내용' 
                        fullWidth 
                        multiline 
                        rows={4} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        defaultValue={item && item.descr}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
            </div>
            <React.Fragment>
                {errorMsg && <ErrorMsg>{errorMsg}</ErrorMsg>}
                {(item && item.sid) ?
                <div style={{display:'grid',gridTemplateColumns:'80% 20%'}}>
                    <Button onClick={()=>handleModClick(sendParam)}>수정</Button>
                    <Button onClick={handleDelConfirm}>삭제</Button>
                </div>
                :
                <div>
                    <Button onClick={()=>handleRegClick(sendParam)}>등록</Button>
                </div>
                }
            </React.Fragment>
            <MsgModal open={delMsgToggle}>
                <div style={{height:'100%',textAlign:'center',display:'flex',flexDirection:'column',justifyContent:'space-between'}} onClick={()=>setDelMsgToggle(false)}>
                    <h2>삭제 하시겠습니까?</h2>
                    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr'}}>
                        <Button onClick={()=>handleDelClick(sendParam)}>삭제</Button>
                        <Button onClick={()=>setDelMsgToggle(false)}>취소</Button>
                    </div>
                </div>
            </MsgModal>
        </MainWrap>
    )
}

export default Detail;